import styled from 'styled-components';
import { palette } from 'styled-tools';

import { Button, fontSize, FontSizes, fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

export const Description = styled.div`
	margin-top: 12px;

	${props =>
		props.theme?.subscribe === 'Calm Health'
			? `
        color: white;
        margin-bottom: 24px;
      `
			: ''}
`;

export const SubmitButton = styled(Button)`
	width: 100%;
	min-width: 200px;
	margin: 16px auto;

	${minWidth('tablet')} {
		width: auto;
	}
`;

export const Help = styled.div`
	margin: 8px auto;
	width: 100%;
	text-align: left;
	font-size: 12px;
	${fontWeight(FontWeights.Medium)};

	${props =>
		props.theme?.subscribe === 'Calm Health'
			? `
        color: white;
      `
			: ''}
`;

export const FaqLink = styled.a`
	${fontWeight(FontWeights.Medium)};
	text-decoration: underline;
	cursor: pointer;
`;

export const Legal = styled.div`
	font-style: italic;
	${fontSize(FontSizes.sm)};
`;

export const GrayLine = styled.div`
	width: 100%;
	height: 1px;
	background-color: ${palette('gray2')};
	margin: 24px auto;
`;
